export default __webpack_public_path__ + "static/media/vasiliysoshnikov.10a12ff1.png";